function mobMenu() {
    const mobMenuOpenBtn = document.querySelector('.js-mob-menu-btn');
    const mobMenuCloseBtn = document.querySelector('.js-close-mob-menu');

    mobMenuOpenBtn.addEventListener('click', () => {
        document.body.classList.add('mobile-menu-open');
    })

    mobMenuCloseBtn.addEventListener('click', () => {
        document.body.classList.remove('mobile-menu-open');
    })
}

export { mobMenu }